var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { inject, observer } from 'mobx-react';
import React from 'react';
import View from '../../elements/View';
import Text from '../../elements/Text';
import { PaymentMethodView } from '../../modules/components/Payments';
import { PaymentMethod } from '../../modules/Reports/Model';
import { T } from '../../helpers/i18n';
import { loading } from '../../elements/Loading';
var PaymentView = /** @class */ (function (_super) {
    __extends(PaymentView, _super);
    function PaymentView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { availablePaymentSelected: null };
        _this.refCash = React.createRef();
        _this.refCard = React.createRef();
        // refCredit: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>()
        _this.refTransf = React.createRef();
        _this.refOther = React.createRef();
        _this.handleTouchable = function (input) {
            var _a;
            (_a = input === null || input === void 0 ? void 0 : input.current) === null || _a === void 0 ? void 0 : _a.focus();
        };
        _this.onClearInput = function (event, ref) {
            ref.current.value = '';
            // event.currentTarget.value = ''
        };
        _this.handleChangeSelect = function (event) {
            console.log("Opci\u00F3n seleccionada: ".concat(event.target.value));
            var id = event.target.value;
            var availablePaymentSelected = _this.props.store.paymentGawewaysStores.availablePayments.find(function (ap) { return ap.id === +id; });
            _this.props.store.tempDuePaymentsStore.paymentSelected = availablePaymentSelected;
            _this.setState({ availablePaymentSelected: availablePaymentSelected });
            console.log('selectedPayment: ', availablePaymentSelected.cardType);
            if (availablePaymentSelected.cardType === 'C') { // tarjeta
                console.log('cambiando el total a pagar por tarjeta');
                _this.props.store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Card);
            }
            else if (availablePaymentSelected.cardType === 'banktrans') { // transferencia
                console.log('cambiando el total a pagar por transferencia');
                _this.props.store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Transfer);
            }
            else {
                throw new Error('no implementado');
            }
        };
        /*if (props.store.paymentGawewaysStores.availablePayments.length >= 1) {
          this.state = {
            // availablePaymentSelected: null,
            availablePaymentSelected: this.props.store.paymentGawewaysStores.availablePayments[1],
          }
          if (this.state.availablePaymentSelected.cardType === 'C') { // tarjeta
            this.props.store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Card)
          } else if (this.state.availablePaymentSelected.cardType === 'banktrans') { // transferencia
            this.props.store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Transfer)
          }
        }*/
        _this.props.store.tempDuePaymentsStore.setTotalDue(_this.props.item.totalDue);
        return _this;
    }
    PaymentView.prototype.render = function () {
        var _a;
        var _b = this.props, store = _b.store, item = _b.item, handleOnChangePay = _b.handleOnChangePay;
        // store.tempDuePaymentsStore.setTotalDue(item.totalDue)
        var _c = store.tempDuePaymentsStore, amountCash = _c.amountCash, amountCard = _c.amountCard, amountTransfer = _c.amountTransfer, amountOther = _c.amountOther;
        var availablePayments = this.props.store.paymentGawewaysStores.availablePayments;
        console.log('availablePayments: ', availablePayments);
        console.log('availablePaymentSelected: ', this.state.availablePaymentSelected);
        if (item.totalDue > 0 && item.agency_id) {
            return (React.createElement(View, null,
                React.createElement(View, null,
                    React.createElement("label", { htmlFor: "available-payments", style: { display: 'block', marginBottom: '8px', fontWeight: 'bold' } }, 'selecciona método de pago'),
                    React.createElement("select", { id: "simple-select-id", value: (_a = this.state.availablePaymentSelected) === null || _a === void 0 ? void 0 : _a.id, onChange: this.handleChangeSelect, style: {
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            minWidth: '200px',
                        } },
                        React.createElement("option", { value: "", disabled: true, selected: true }, "-- Selecciona --"),
                        availablePayments.map(function (option) { return (React.createElement("option", { key: option.alias, value: option.id }, "".concat(option.alias, " ").concat(option.displayName))); }))),
                React.createElement(View, null,
                    React.createElement("label", null, "Total a pagar ".concat(store.tempDuePaymentsStore.totalToDue)))));
        }
        var errorTotalToPay = store.tempDuePaymentsStore.totalToDue !== item.totalDue;
        var totalToPay = store.tempDuePaymentsStore.totalToDue;
        var message = "El importe a pagar es ".concat(totalToPay > item.totalDue ? 'mayor' : 'menor', " al pendiente de cobro");
        return (React.createElement(View, null,
            errorTotalToPay &&
                React.createElement(Text, { center: true, primary: true }, message),
            React.createElement(View, { flex: true, row: true },
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Cash, enabled: true, title: T(PaymentMethod.Cash), selected: store.tempDuePaymentsStore.amountCash > 0, refInput: this.refCash, value: store.tempDuePaymentsStore.amountCash, moneyName: item.money, onHandleClick: function () {
                    }, onHandleInput: function (input, ref) {
                        handleOnChangePay(PaymentMethod.Cash, input);
                    }, onClearInput: function (input, ref) {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: function () {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Cash);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Card, enabled: true, title: T(PaymentMethod.Card), selected: store.tempDuePaymentsStore.amountCard > 0, refInput: this.refCard, value: store.tempDuePaymentsStore.amountCard, moneyName: item.money, onHandleClick: function () {
                    }, onHandleInput: function (input, ref) {
                        handleOnChangePay(PaymentMethod.Card, input);
                    }, onClearInput: function (input, ref) {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: function () {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Card);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Transfer, enabled: true, title: T(PaymentMethod.Transfer), selected: store.tempDuePaymentsStore.amountTransfer > 0, refInput: this.refTransf, value: store.tempDuePaymentsStore.amountTransfer, moneyName: item.money, onHandleClick: function () {
                    }, onHandleInput: function (input, ref) {
                        handleOnChangePay(PaymentMethod.Transfer, input);
                    }, onClearInput: function (input, ref) {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: function () {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Transfer);
                    } }),
                React.createElement(PaymentMethodView, { small: true, method: PaymentMethod.Other, enabled: true, title: T(PaymentMethod.Other), selected: store.tempDuePaymentsStore.amountOther > 0, refInput: this.refOther, value: store.tempDuePaymentsStore.amountOther, moneyName: item.money, onHandleClick: function () {
                    }, onHandleInput: function (input, ref) {
                        handleOnChangePay(PaymentMethod.Other, input);
                    }, onClearInput: function (input, ref) {
                        ref.current.value = '';
                    }, onHandleAllMoneyClick: function () {
                        store.tempDuePaymentsStore.setAllMoneyToPaymentMethod(PaymentMethod.Other);
                    } }))));
    };
    PaymentView = __decorate([
        inject('store'),
        loading(function (props) {
            var _a, _b;
            if (((_a = props.item) === null || _a === void 0 ? void 0 : _a.agency_id) && ((_b = props.item) === null || _b === void 0 ? void 0 : _b.totalDue) > 0) {
                return [
                    props.store.paymentGawewaysStores.getPaymentTokens(props.item.agency_id)
                ];
            }
            return [];
        }),
        observer
    ], PaymentView);
    return PaymentView;
}(React.Component));
export { PaymentView };



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/PaymentView.tsx
// module id = 1195
// module chunks = 0